import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-topLeft",
  "use": "icon-topLeft-usage",
  "viewBox": "0 0 24 23",
  "content": "<symbol viewBox=\"0 0 24 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-topLeft\">\n<path d=\"M14.8284 20.9304C13.2663 22.4925 10.7337 22.4925 9.17157 20.9304L0.120604 11.8794L12 2.80738e-09L23.8794 11.8794L14.8284 20.9304Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol